
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq0NXe8B65mr9nc1deccUlnn9U0jj_45l98bL2j9PlX266IMeta } from "/codebuild/output/src512590905/src/src/pages/faq.vue?macro=true";
import { default as menu9LuLYJ7ZazfAvpfhRlUY6TquSA7jYo64cEyraw5n2rUMeta } from "/codebuild/output/src512590905/src/src/pages/menu.vue?macro=true";
import { default as indexBa2ZERP5SGPZOJWmTdMj5z79J1wseeZXbhd2z6AgpioMeta } from "/codebuild/output/src512590905/src/src/pages/index.vue?macro=true";
import { default as contactv5Tv_45dBAG1HfeB2bl8Zr24cZOGYfj8WKrEUW9ixZ9aUMeta } from "/codebuild/output/src512590905/src/src/pages/contact.vue?macro=true";
import { default as tutoriallX61A7HjVhr8a_45nqwoP0WVRAcihzQdYsKzRuf_LIp4wMeta } from "/codebuild/output/src512590905/src/src/pages/tutorial.vue?macro=true";
import { default as agreementgIv0AhMh_45QP799m0SbdmVdchmvAuf0oodAxnZ3XSd6MMeta } from "/codebuild/output/src512590905/src/src/pages/agreement.vue?macro=true";
import { default as about_45passJsuE7x0QmYC5RjatYkhxH0XWY1Z_bXJMGBHuxwurhEEMeta } from "/codebuild/output/src512590905/src/src/pages/about-pass.vue?macro=true";
import { default as indexenkDyInI1WFCXZI_fE2aiR4mCdj2HNsd_l6IPCvTQlIMeta } from "/codebuild/output/src512590905/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Mag3drGEeQihZWc4oKPX90dvn3XfLxbWfOHnbtYt1eQMeta } from "/codebuild/output/src512590905/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance5ZjeYUAVFbjoas_M326nbMQylgFyDDFfQC14LVcf2FEMeta } from "/codebuild/output/src512590905/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93vG5pFiPHdrecD_BgaTXIKPsSD_45MdqKdm9Ces9msNpg8Meta } from "/codebuild/output/src512590905/src/src/pages/notice/[id].vue?macro=true";
import { default as index1U9_LyzBJMVjZCYMkeref4f1Wmz3VLBdMflCScwp8BMMeta } from "/codebuild/output/src512590905/src/src/pages/coupon/index.vue?macro=true";
import { default as indexg_Uyp39AgL6cLLLdMMFyA9Kw5RIkVHM6soFVciZLyi4Meta } from "/codebuild/output/src512590905/src/src/pages/mypage/index.vue?macro=true";
import { default as indexUTgqUR9_1g8Vkc6mIloEuE9iFoVBCjeQRbhT2n_SjsQMeta } from "/codebuild/output/src512590905/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93I_7KXZCh9ShVzPiNckrIvNg_459EUJxjCdPrUNL1T_45cGEMeta } from "/codebuild/output/src512590905/src/src/pages/parking/[id].vue?macro=true";
import { default as indexFPHs65jCY1tcvjJ3OwfK3C7LSVWo1I7f0ZwPg8i9h58Meta } from "/codebuild/output/src512590905/src/src/pages/history/index.vue?macro=true";
import { default as index_q80oHHLsHvzxrdpua4w_6TgdDs20Sy6Sokn7yvOI18Meta } from "/codebuild/output/src512590905/src/src/pages/monthly/index.vue?macro=true";
import { default as indexF_45wQHWoiI2OiU7QuMSfiXKATPL2mD48qhAEaLD98fpYMeta } from "/codebuild/output/src512590905/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexzoSYDYC0j4yQhjT7yHrbiWJwh5usI_45i9gTmvbcCKssYMeta } from "/codebuild/output/src512590905/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviZ_PfmAyuj_45Zz51Rm9fyhH0O4on3STcU8XTE885h3fDMMeta } from "/codebuild/output/src512590905/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit0sZANx70FToPPf2KpQn2s8gwBhIZggGBLs8TN505LvcMeta } from "/codebuild/output/src512590905/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementmhRrvcQLysfZlOjhiN5ugFMqq_F8Ldggv5T_l12aYbcMeta } from "/codebuild/output/src512590905/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexHJQGWVXq3hO8YcP4ajccLfNmD5_y8Y8UKR_45ojJ6OoScMeta } from "/codebuild/output/src512590905/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dLM4HWLMJWct7Km9x2ibGjbuX6pVtpteivSyDCiOC6dgMeta } from "/codebuild/output/src512590905/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmRelBb0wtxms_45RdsGgjRTC96i58kWsD88d05ndnX8aCMMeta } from "/codebuild/output/src512590905/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexSHFdrwRLeGZmHQ_FF0O2bEfASQC_45vnC53lUMW9UpfdoMeta } from "/codebuild/output/src512590905/src/src/pages/card/create/index.vue?macro=true";
import { default as indexMc1hBUsDzfhboax5nJAn2vOvZRMvLk5ljaTPk4NHjscMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmbAWNDDkFQgXPSX1kwiYE2ZZfPrRjjm0DIaTVDAUe5PEMeta } from "/codebuild/output/src512590905/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmtYu1tuhNc1JgXWoYUti2lB47jSgKuD59A27n2ZBkt6YMeta } from "/codebuild/output/src512590905/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeoAE5lzt9gXGFxeIeSt_45BvzukyN8mpAJigkh3I5emhCsMeta } from "/codebuild/output/src512590905/src/src/pages/membership/complete.vue?macro=true";
import { default as registeriviN1LuWuCWOY_ibyfWDfMEuS79NVwTdSDCxgxVtaKEMeta } from "/codebuild/output/src512590905/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93fgWhxReuEa5A_wEKfv1CqXNdqF5YMZdQcVh66GtRV24Meta } from "/codebuild/output/src512590905/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmGGQXpkvUxmJc9_5d6_i0Ys_JM0pgJiDCcHztfNKfIjYMeta } from "/codebuild/output/src512590905/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93MW0CUeXmnen1aHMraNuDWG0N1k1UNkKQdUKlY1ixPXUMeta } from "/codebuild/output/src512590905/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexZzSPkzGfDRLfU1hcNRiP_V3A9UGS13_45plPEu0LzuctcMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codexlXsDssswbOj_zxMlhyPlykyo1EkFgepvrkrKtAQMLcMeta } from "/codebuild/output/src512590905/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeekuJy1BWzZOD5HVWSe7jMOE9anYXmmCY6_45vzqGRLUqAMeta } from "/codebuild/output/src512590905/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeyFlcc5sWmRPCeKeuUq9Qo3Pz0dwBcEe31G07t6uey_AMeta } from "/codebuild/output/src512590905/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerwkZ6W_45C_zwMOInO_23izdPNCd5npVl8DdTtjNH3vZLcMeta } from "/codebuild/output/src512590905/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeZVV4Gh651_45BsJ_k8Nd4p_XvgHLABrQ9tlMrxhkWupzUMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexL12wLnqqCuKFvvs2ztCFuOUnCsnajvs_ZdAOokZOnWIMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm5f9zOTsae5vqqxJYplfVheqCMJNbIvt66_45akExcoqkAMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete2OIkHj5VEZKR3E20kWWralEqXtPLf4jXuiy7q_45gPf2gMeta } from "/codebuild/output/src512590905/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexk_458_A0SxmHY_452m4i_Ia6KS3ODTxFRwQmjWnEzD_45wTwwMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_9302t6I_45R4Dn46aXoH6HfCXulUpBENshbMU0yTWrCZIf4Meta } from "/codebuild/output/src512590905/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeNPIdH8z3dSivaKt6hBm83nC7Xcc_8a7RbOJP3ewcQJkMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasZMVKoBgAdqtZD5tUyqD4_456IglxBSTbweQN2Sd06_siIMeta } from "/codebuild/output/src512590905/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplezRfwvy6ac455OKiGiHTNa8gDVztIuIzQmk_JRK4jIJMMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email6U60sKl0p56QF7su3SfKAQosWHWGLLhN7ZhrKd1rUEwMeta } from "/codebuild/output/src512590905/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm1_45X42I_45Y9WAU_DRN_wzAGoncaBdMItI1rnIpeYHjmlAMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentmb_bA4BkFvsj069vTnEZTDmFkIVBHfMAFF3_45Fs5Pb1MMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm451eBQSExD4_45sBRRDsUZoSaJsemS6_A_sWhglZoF4sMMeta } from "/codebuild/output/src512590905/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatemzRqSVUTB1Ht1g0urnQ0Fc8ZJCJ4DzYMUZlKId8mTKAMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeEV7S7MJwKXiQKrlHHwbBhLK32qSlRXsr9BxGKCvP5vgMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeB5bs3PQBvZwYVFlDhi_MMxduhhPHXrrufYz3_45WTw_uAMeta } from "/codebuild/output/src512590905/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordgagzX2zHzKiiTwE6b3su_IVs3MyLa_0hrjdKemSsF7UMeta } from "/codebuild/output/src512590905/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasJS_oCpsanicR__jGgVygaAgedSEZk_ACDwjAFzkZAewMeta } from "/codebuild/output/src512590905/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerdbtKrwtaIT8esyMR0qwtlapKVGzcrg5zyTbETdXk9MAMeta } from "/codebuild/output/src512590905/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeg2qwW4ONGiEwv_45fPGxuZMXQ_45_IXp_45FZ_BJNwyr2iY2IMeta } from "/codebuild/output/src512590905/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexmkF6SU3I3PNWTOaM6i1Y5xpA8bGGQ8wPySdclD4gAmYMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexJqP1EzRIOO29qG4jZwUX44JI2vJ4twFWasoqa12B4BEMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexU9pN6UFJ1E4_45SSRI9lY4M7LrkbUIgfyEEHzqnLGpFLQMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexmtr6e28xnsT0a8v6s8244Hbh9N_KWNUleJGwtfw9NtYMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update5I3oIKsPoUtLqURfJ1Q0ch646kNlS3m5XuodU7waX0kMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completexSmqaI4LAZUaHXdwA1tPc8xnOpafD23ULL1BbtC5Vt0Meta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm_5XFLctSTtlWkZSYuNm_MIHme16tlzuujxbsGoFS6oAMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexoU4P1l6sKJEh_PBF78Xp7JiKkM7EW1zwggzwY4clep0Meta } from "/codebuild/output/src512590905/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeE28PiNbREb2rb_6UT_6sXrscVV6bzKo3hDDISKkestYMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateu59C7BXE27BVoegrnDIY4_fWqkSnpW4HrHBisuN3ZgMMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexQzt54aqet8oqRRz7MV_45xi9farYAseDJeubeym9Mq2XcMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexYDljk_yqGSB7Wqww3lUYcWJnd_LVrSZYSNSpZ47WKEEMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeDpxMqvcv_45t0AU_SDhrlilUX6DQutP7YDPT0Xb7Mq8jsMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index_4559CAGIfLmUWue0VaHZWMlkjVIGPLzzSOetxsMSHU6QMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codexk8ehSik0Eusld7EsH4ld47p6YfocJXavfy8ceSYP6YMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexwnSUx7J9JeybPCWTU8Z7sq_HsHEog3Ayw1aqzjebxecMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexc8DMpwMKVl0ZeFVZxC5_45Weh8yNyJ1zEnIJIgzFyip7gMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index3fwEbFCHC_UOB8ymzLGIDs0QBfDSkKOvnoYW6_Y_45MzAMeta } from "/codebuild/output/src512590905/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatezOD_456pTcl3sLZH_DQqMKOYgpsMAFW_5KK6k7fs8IPEYMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmyJMvXWE9xi51OcZaoy_45jv7letzWCinv_r2Xv7bT8NdAMeta } from "/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src512590905/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu9LuLYJ7ZazfAvpfhRlUY6TquSA7jYo64cEyraw5n2rUMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexBa2ZERP5SGPZOJWmTdMj5z79J1wseeZXbhd2z6AgpioMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src512590905/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src512590905/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src512590905/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src512590905/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src512590905/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index1U9_LyzBJMVjZCYMkeref4f1Wmz3VLBdMflCScwp8BMMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src512590905/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src512590905/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexFPHs65jCY1tcvjJ3OwfK3C7LSVWo1I7f0ZwPg8i9h58Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexF_45wQHWoiI2OiU7QuMSfiXKATPL2mD48qhAEaLD98fpYMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexzoSYDYC0j4yQhjT7yHrbiWJwh5usI_45i9gTmvbcCKssYMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src512590905/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src512590905/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexSHFdrwRLeGZmHQ_FF0O2bEfASQC_45vnC53lUMW9UpfdoMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmbAWNDDkFQgXPSX1kwiYE2ZZfPrRjjm0DIaTVDAUe5PEMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmtYu1tuhNc1JgXWoYUti2lB47jSgKuD59A27n2ZBkt6YMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeoAE5lzt9gXGFxeIeSt_45BvzukyN8mpAJigkh3I5emhCsMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registeriviN1LuWuCWOY_ibyfWDfMEuS79NVwTdSDCxgxVtaKEMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmGGQXpkvUxmJc9_5d6_i0Ys_JM0pgJiDCcHztfNKfIjYMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codexlXsDssswbOj_zxMlhyPlykyo1EkFgepvrkrKtAQMLcMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeekuJy1BWzZOD5HVWSe7jMOE9anYXmmCY6_45vzqGRLUqAMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeyFlcc5sWmRPCeKeuUq9Qo3Pz0dwBcEe31G07t6uey_AMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerwkZ6W_45C_zwMOInO_23izdPNCd5npVl8DdTtjNH3vZLcMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm5f9zOTsae5vqqxJYplfVheqCMJNbIvt66_45akExcoqkAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete2OIkHj5VEZKR3E20kWWralEqXtPLf4jXuiy7q_45gPf2gMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexk_458_A0SxmHY_452m4i_Ia6KS3ODTxFRwQmjWnEzD_45wTwwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeNPIdH8z3dSivaKt6hBm83nC7Xcc_8a7RbOJP3ewcQJkMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplezRfwvy6ac455OKiGiHTNa8gDVztIuIzQmk_JRK4jIJMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email6U60sKl0p56QF7su3SfKAQosWHWGLLhN7ZhrKd1rUEwMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm1_45X42I_45Y9WAU_DRN_wzAGoncaBdMItI1rnIpeYHjmlAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentmb_bA4BkFvsj069vTnEZTDmFkIVBHfMAFF3_45Fs5Pb1MMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm451eBQSExD4_45sBRRDsUZoSaJsemS6_A_sWhglZoF4sMMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeEV7S7MJwKXiQKrlHHwbBhLK32qSlRXsr9BxGKCvP5vgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeB5bs3PQBvZwYVFlDhi_MMxduhhPHXrrufYz3_45WTw_uAMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordgagzX2zHzKiiTwE6b3su_IVs3MyLa_0hrjdKemSsF7UMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src512590905/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerdbtKrwtaIT8esyMR0qwtlapKVGzcrg5zyTbETdXk9MAMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeg2qwW4ONGiEwv_45fPGxuZMXQ_45_IXp_45FZ_BJNwyr2iY2IMeta || {},
    component: () => import("/codebuild/output/src512590905/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src512590905/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src512590905/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]